import React from 'react';
import { DraggableProvided, DraggableStateSnapshot, DraggingStyle, NotDraggingStyle } from 'react-beautiful-dnd';
import { AnyObject } from 'final-form';
import { HorizonInterval } from 'src/models/Horizon';
import ReactDOM from 'react-dom';

// TODO: Further abstract these interface props away from Horizon Sequencing Component
interface IPortalAwareItemProps {
    provided: DraggableProvided;
    snapshot: DraggableStateSnapshot;
    item: AnyObject;
    portal: HTMLElement;
    getItemStyle: (isDragging: boolean, draggableStyle: DraggingStyle | NotDraggingStyle, horizonInterval: AnyObject) => React.CSSProperties;
    customDetailFormat?: (interval: AnyObject) => JSX.Element | JSX.Element[] | string;
}

class PortalAwareItem extends React.Component<IPortalAwareItemProps> {
    render() {
        const provided: DraggableProvided = this.props.provided;
        const snapshot: DraggableStateSnapshot = this.props.snapshot;
        const item: AnyObject = this.props.item;

        const usePortal: boolean = snapshot.isDragging;

        const child = (
            <div
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                style={this.props.getItemStyle(snapshot.isDragging, provided.draggableProps.style, item as HorizonInterval)}
            >
                {this.props.customDetailFormat ? this.props.customDetailFormat(item as HorizonInterval) : item.toString()}
            </div>
        );

        if (!usePortal) {
            return child;
        }

        return ReactDOM.createPortal(child, this.props.portal);
    }
}

export default PortalAwareItem;


// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/PortalAwareItem.tsx